import { GpsTrackersPlataformaService } from "../../../shared/generated/grpc/plataforma_hardware_gps_trackers_pb";
import { GpsTrackerResponse } from "../../../shared/response/hardware/GpsTrackerResponse";
import { GpsTrackerPayload } from "../../../shared/services/api/payload/hardware/GpsTrackerPayload";
import { ServiceSaveBase } from "../../../shared/services/base/ServiceSaveBase";
import { dateToMs, grpcCall, grpcClient } from "../../../shared/services/grpc/grpcCall";
import { GpsTrackerService, toGpsTrackerResponse } from "./GpsTrackerService";

/** Alta y edición de los datos de testeo; el resultado reemplaza la fila del listado. */
export class GpsTrackerSaveService extends ServiceSaveBase<GpsTrackerResponse, GpsTrackerPayload> {
  protected readonly cache = GpsTrackerService.instance;

  /** gRPC-Web (`Guardar`): sin `id` crea (código interno del servidor, en oficina); si pasa el test se limpia la nota. */
  protected async sendSave(p: GpsTrackerPayload): Promise<GpsTrackerResponse> {
    const t = await grpcCall(() => grpcClient(GpsTrackersPlataformaService).guardar({
      id: p.id ?? undefined,
      fechaTesteo: dateToMs(p.fechaTesteo),
      pasaTest: p.pasaTest,
      notaTest: p.notaTest ?? undefined,
    }));
    return toGpsTrackerResponse(t);
  }
}
